"use client";
import { useState } from "react";
import { avatarImg } from "@/lib/imgUrl";

// ONE reviewer-face door (root fix 15/10/26, missing reviewer photos): a photo that fails to load (file missing / 404 / blocked)
// NEVER shows a broken image — it falls back to OUR Hebrew-initial avatar (same colour formula as ReviewsList / reviewerInitialBg).
// `wrap` lets a caller (AvatarZoom) wrap only the real photo; the initial fallback is never zoomable.
export default function ReviewerFaceImg({ src, name, size, wrap, initial = true, className = "rounded-full object-cover flex-shrink-0", style, fontSize }: {
  src: string; name: string; size: number; wrap?: (img: React.ReactNode) => React.ReactNode; initial?: boolean;
  className?: string; style?: React.CSSProperties; fontSize?: number;
}) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    if (!initial) return null;
    return (
      <span className="rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" aria-hidden="true"
        style={{ width: size, height: size, fontSize: fontSize || Math.round(size * 0.46), background: `hsl(${((name || "?").charCodeAt(0) * 37) % 360},60%,42%)` }}>{(name || "?")[0] || "?"}</span>
    );
  }
  const img = (
    <img {...avatarImg(src, size)} alt={name} referrerPolicy="no-referrer" loading="lazy" decoding="async" width={size} height={size}
      onError={() => setFailed(true)} className={className} style={{ width: size, height: size, ...style }} />
  );
  return <>{wrap ? wrap(img) : img}</>;
}
